export const API_BASE = `https://detoxme.at/wp/wp-json/siegfried/v1`;

export const FACEBOOK_PIXEL_ID = '674763123483966';
export const GOOGLE_ANALYTICS_KEY = 'G-GGHEBS73GN';//'G-GGHEBS73GN';
export const LINKEDIN_PIXEL_ID = '3249674';
export const LINKEDIN_CONVERSION_ID = '';
export const HOTJAR_KEY = 2480061;
export const HOTJAR_SNIPPET_VERSION = 6; //HSV
export const GOOGLE_TAG_MANAGER_KEY = 'GTM-K49NLBP';